import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { PullRequestReviews, Overview, OverTime } from '#screens/Stats/PullRequestReviews';

export const StatsNavigator = () => (
  <Routes>
    <Route path="/pull-request-reviews" element={<PullRequestReviews />}>
      <Route index element={<Navigate to="overview" />} />
      <Route path="overview" element={<Overview />} />
      <Route path="over-time" element={<OverTime />} />
      <Route path="*" element={<Navigate to="overview" />} />
    </Route>
  </Routes>
);
